(() => {
  const initialize = (root) => {
    if (root.dataset.acGiftsMegaReady === "true") return;

    const triggers = Array.from(root.querySelectorAll("[data-ac-gifts-trigger]"));
    const panels = Array.from(root.querySelectorAll("[data-ac-gifts-panel]"));
    const defaultPanel = root.querySelector('[data-ac-gifts-panel="default"]');
    if (!triggers.length || !defaultPanel) return;

    const activate = (requestedKey) => {
      const activePanel = panels.find((panel) => panel.dataset.acGiftsPanel === requestedKey) || defaultPanel;
      panels.forEach((panel) => { panel.hidden = panel !== activePanel; });
      triggers.forEach((trigger) => {
        const isActive = trigger.dataset.acGiftsTrigger === activePanel.dataset.acGiftsPanel;
        trigger.dataset.active = String(isActive);
        trigger.setAttribute("aria-pressed", String(isActive));
      });
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener("pointerenter", () => activate(trigger.dataset.acGiftsTrigger));
      trigger.addEventListener("focusin", () => activate(trigger.dataset.acGiftsTrigger));
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        activate(trigger.dataset.acGiftsTrigger);
      });
    });

    const disclosure = root.closest("details");
    disclosure?.addEventListener("toggle", () => {
      if (!disclosure.open) activate("default");
    });
    root.addEventListener("pointerleave", () => activate("default"));
    root.dataset.acGiftsMegaReady = "true";
    activate("default");
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll("[data-ac-gifts-mega]").forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll());
  } else {
    initializeAll();
  }
  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
})();
